var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "Edit"
    },
    [
      _c(
        "el-header",
        { staticClass: "Edit-header" },
        [
          _c("el-page-header", {
            attrs: { content: _vm.title },
            on: { back: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "Edit-main" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "创意类型名称", prop: "ideaTypeName" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.ideaTypeName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ideaTypeName", $$v)
                      },
                      expression: "form.ideaTypeName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "代码位类型", prop: "slotType" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.slotType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "slotType", $$v)
                        },
                        expression: "form.slotType"
                      }
                    },
                    _vm._l(_vm.myOption.slotType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { required: "", label: "创意类型元素" } },
                [
                  _c(
                    "ul",
                    { staticClass: "idea-type" },
                    _vm._l(_vm.ideaData, function(item, index) {
                      return _c(
                        "li",
                        { key: index },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { width: "120px" },
                              model: {
                                value: item.checked,
                                callback: function($$v) {
                                  _vm.$set(item, "checked", $$v)
                                },
                                expression: "item.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.myOption.getIdData(
                                    "ideaType",
                                    item.assetsId,
                                    "name"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          item.checked
                            ? _c("ul", { staticClass: "idea-type-param" }, [
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { size: "mini" },
                                        model: {
                                          value: item.required,
                                          callback: function($$v) {
                                            _vm.$set(item, "required", $$v)
                                          },
                                          expression: "item.required"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio-button",
                                          {
                                            attrs: {
                                              label: _vm.myOption.is.false
                                            }
                                          },
                                          [_vm._v("选填")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio-button",
                                          {
                                            attrs: {
                                              label: _vm.myOption.is.true
                                            }
                                          },
                                          [_vm._v("必填")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                item.data.width !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "6px"
                                            }
                                          },
                                          [_vm._v("宽度")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { width: "80px" },
                                          attrs: { size: "mini" },
                                          on: {
                                            input: function($event) {
                                              return _vm.errorNumber(
                                                index,
                                                "data",
                                                "width"
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.data.width,
                                            callback: function($$v) {
                                              _vm.$set(item.data, "width", $$v)
                                            },
                                            expression: "item.data.width"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px"
                                            }
                                          },
                                          [_vm._v("px")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                              color: "#F56C6C"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.tip[0]))]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.data.height !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "6px"
                                            }
                                          },
                                          [_vm._v("高度")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { width: "80px" },
                                          attrs: { size: "mini" },
                                          on: {
                                            input: function($event) {
                                              return _vm.errorNumber(
                                                index,
                                                "data",
                                                "height"
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.data.height,
                                            callback: function($$v) {
                                              _vm.$set(item.data, "height", $$v)
                                            },
                                            expression: "item.data.height"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px"
                                            }
                                          },
                                          [_vm._v("px")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                              color: "#F56C6C"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.tip[1]))]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.data.minLen !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "6px"
                                            }
                                          },
                                          [_vm._v("最小长度")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { width: "80px" },
                                          attrs: { size: "mini" },
                                          on: {
                                            input: function($event) {
                                              return _vm.errorNumber(
                                                index,
                                                "data",
                                                "minLen"
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.data.minLen,
                                            callback: function($$v) {
                                              _vm.$set(item.data, "minLen", $$v)
                                            },
                                            expression: "item.data.minLen"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px"
                                            }
                                          },
                                          [_vm._v("字")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                              color: "#F56C6C"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.tip[0]))]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.data.maxLen !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "6px"
                                            }
                                          },
                                          [_vm._v("最大长度")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { width: "80px" },
                                          attrs: { size: "mini" },
                                          on: {
                                            input: function($event) {
                                              return _vm.errorNumber(
                                                index,
                                                "data",
                                                "maxLen"
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.data.maxLen,
                                            callback: function($$v) {
                                              _vm.$set(item.data, "maxLen", $$v)
                                            },
                                            expression: "item.data.maxLen"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px"
                                            }
                                          },
                                          [_vm._v("字")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                              color: "#F56C6C"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.tip[1]))]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.data.minTime !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "6px"
                                            }
                                          },
                                          [_vm._v("最小时长")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { width: "80px" },
                                          attrs: { size: "mini" },
                                          on: {
                                            input: function($event) {
                                              return _vm.errorNumber(
                                                index,
                                                "data",
                                                "minTime"
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.data.minTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item.data,
                                                "minTime",
                                                $$v
                                              )
                                            },
                                            expression: "item.data.minTime"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px"
                                            }
                                          },
                                          [_vm._v("秒")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                              color: "#F56C6C"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.tip[0]))]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.data.maxTime !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-right": "6px"
                                            }
                                          },
                                          [_vm._v("最大时长")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { width: "80px" },
                                          attrs: { size: "mini" },
                                          on: {
                                            input: function($event) {
                                              return _vm.errorNumber(
                                                index,
                                                "data",
                                                "maxTime"
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.data.maxTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item.data,
                                                "maxTime",
                                                $$v
                                              )
                                            },
                                            expression: "item.data.maxTime"
                                          }
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px"
                                            }
                                          },
                                          [_vm._v("秒")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                              color: "#F56C6C"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.tip[1]))]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.data.mimes !== undefined
                                  ? _c(
                                      "li",
                                      [
                                        _c(
                                          "el-checkbox-group",
                                          {
                                            attrs: { min: _vm.imgMinNum },
                                            model: {
                                              value: item.data.mimes,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item.data,
                                                  "mimes",
                                                  $$v
                                                )
                                              },
                                              expression: "item.data.mimes"
                                            }
                                          },
                                          [
                                            item.assetsId !== 17
                                              ? [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "image/jpeg"
                                                      }
                                                    },
                                                    [_vm._v("JPEG")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "image/png"
                                                      }
                                                    },
                                                    [_vm._v("PNG")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "image/gif"
                                                      }
                                                    },
                                                    [_vm._v("GIF")]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "video/mp4"
                                                      }
                                                    },
                                                    [_vm._v("MP4")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        label: "video/flv"
                                                      }
                                                    },
                                                    [_vm._v("FLV")]
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "备注", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("form")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _vm.isModel !== 2
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.resetForm("form")
                            }
                          }
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aa411b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa411b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idea_type/Edit.vue
// module id = 8hs2
// module chunks = 1